import React, { useContext, useEffect, useState } from "react";
import PageContext from "../../Common/PageContext";
import { useListTransfers } from "./api/useListTransfers";
import { translateError } from "../../../util/axiosUtils";
import { LoadingDialog } from "../../Loading/LoadingDialog";
import { ModalBase } from "../../Modal/ModalBase";
import alertTypeEnum from "../../../util/alertTypeEnum";
import modalSize from "../../../util/modalSizeEnum";
import { Container, Grid2 as Grid, Typography } from "@mui/material";
import TransferCard from "../TransferCard/TransferCard";
import { useStyles } from "../Transfer.styles";
import useQuery from "../../../useQuery";
import { transferStatus } from "../../../util/transferStatus";
import { receiveStatus } from "../../../util/receiveStatus";

export type TransferListProps = {
	pageName: string;
	pageTitle: string;
};

const TransferList: React.FC<TransferListProps> = ({ pageName, pageTitle }) => {
	const classes = useStyles();
	const [pageContext] = useContext(PageContext);
	const { userLocation } = pageContext;
	const timestamp = useQuery().get("t");

	const [{ data: transfers, loading: isLoading, error: apiError }, refreshTransfers] = useListTransfers(
		pageName,
		userLocation,
		true
	);

	useEffect(() => {
		void refreshTransfers();
	}, [refreshTransfers, timestamp]);

	const [alertModal, setAlertModal] = useState({
		isOpen: false,
		message: "",
	});

	useEffect(() => {
		if (apiError) {
			let message = translateError(apiError);
			if (!message) message = "Failed to fetch transfers";
			setAlertModal((a) => {
				return { ...a, message, isOpen: true };
			});
		} else {
			setAlertModal((a) => {
				return { ...a, message: "", isOpen: false };
			});
		}
	}, [apiError]);

	const closeModal = () => {
		setAlertModal({
			isOpen: false,
			message: "",
		});
	};

	return (
		<Container disableGutters>
			<LoadingDialog isOpen={isLoading} message="Loading" />
			<ModalBase
				{...alertModal}
				title="Error"
				alertType={alertTypeEnum.ERROR}
				primaryButtonName="OK"
				onPrimaryButtonClick={closeModal}
				onSecondaryButtonClick={closeModal}
				onClose={closeModal}
				size={modalSize.DEFAULT}
			/>
			<Typography variant="h5">{pageTitle}</Typography>
			{transfers && (
				<>
					<Typography variant="body1" display="inline">
						{transfers.transfers.length + " " + transfers.message}
					</Typography>
					{transfers.transfers.length > 0 && (
						<Grid container direction="column" wrap={"nowrap"} className={classes.transferListContainer}>
							{transfers.transfers.map((transfer) => (
								<Grid size="grow" key={`${transfer.id}`}>
									<TransferCard
										receiveStatus={
											transfer.receiveStatus ??
											(transfer.status === transferStatus.completed ||
											transfer.status === transferStatus.completedWithVariances ||
											transfer.status === transferStatus.completedManuallyRecievedInSK
												? receiveStatus.receivedDirectly
												: receiveStatus.open)
										}
										transfer={transfer}
									/>
								</Grid>
							))}
						</Grid>
					)}
				</>
			)}
		</Container>
	);
};

export default TransferList;
